import type { ArticlePreview } from '$lib/utils/definitions';

export const articles: ArticlePreview[] = [
  {
    title:
      'Achat d’un logement social (hors du cadre de la vente HLM) : Le Bail Réel Solidaire (BRS) pourrait vous permettre de devenir propriétaire !',
    pageTitle:
      'Achat d’un logement social (hors vente HLM) : comment devenir propriétaire grâce au Bail Réel Solidaire (BRS)',
    description:
      'Achat d’un logement social (hors du cadre de la vente HLM) : la solution du Bail Réel Solidaire (BRS). Découvrez comment devenir propriétaire d’un logement social à prix abordable.',
    firstPublishedAt: '2026-08-31T09:00:00+02:00',
    slug: 'achat-logement-social-bail-reel-solidaire-brs',
  },
  {
    title:
      'Plafonds de revenus BRS 2026 : tableau complet par zone et composition de ménage',
    description:
      'Découvrez les plafonds de revenus BRS 2026 par zone et composition de ménage, la comparaison avec 2025 et les étapes pour vérifier votre éligibilité.',
    firstPublishedAt: '2026-06-05T10:43:00+02:00',
    slug: 'plafonds-de-revenus-brs-2026-tableau-complet-par-zone-et-composition-de-menage',
  },
  {
    title:
      'Inconvénients en bail réel solidaire : des règles, des limites à respecter. Renseignez-vous sur la plateforme du gouvernement.',
    pageTitle:
      "Les inconvénients du bail réel solidaire - Ou plus exactement ses contreparties. Ce qu'il faut savoir avant de se lancer.",
    description:
      "Des inconvénients en bail réel solidaire ? Découvrez les contreparties d'un achat en BRS sur la plateforme du Ministère du logement.",
    firstPublishedAt: '2025-12-04T10:38:39.527438+01:00',
    slug: 'les-inconvenients-ou-contreparties-du-bail-reel-solidaire-brs',
  },
  {
    title:
      'La succession en bail réel solidaire (BRS) : quelles sont les règles ?',
    description: `Que devient un logement en bail réel solidaire (BRS) en cas de succession ? Découvrez les règles d'héritage, les droits des héritiers et les conditions pour transmettre un bien en bail réel solidaire. Succession possible mais encadrée.`,
    firstPublishedAt: '2025-08-20T14:23:00.527438+01:00',
    updatedAt: '2026-05-28T00:00:00+02:00',
    slug: 'la-succession-en-bail-reel-solidaire-brs',
  },
  {
    title: 'Comment savoir si je suis éligible au bail réel solidaire (BRS) ?',
    description: `Découvrez si vous êtes éligible au bail réel solidaire (BRS). Critères, plafonds de revenus, exemples concrets et simulateur officiel pour tout savoir.`,
    firstPublishedAt: '2025-07-01T09:45:00.527438+01:00',
    slug: 'comment-savoir-si-je-suis-eligible-au-bail-reel-solidaire-brs',
  },
  {
    title: '5 idées reçues sur le bail réel solidaire (BRS)',
    description: `Le bail réel solidaire (BRS) souffre de quelques fausses idées: "je ne pourrai jamais revendre", "je ne suis pas propriétaire"… Découvrez la vérité sur le bail réel solidaire (BRS) via BoRiS, plateforme officielle du gouvernement dédiée au bail réel solidaire.`,
    firstPublishedAt: '2025-06-25T16:12:39.527438+01:00',
    updatedAt: '2026-05-28T00:00:00+02:00',
    slug: '5-idees-recues-sur-le-bail-reel-solidaire-brs',
  },
  {
    title: "Le Bail Réel Solidaire (BRS), c'est quoi exactement?",
    description:
      "Découvrez le Bail Réel Solidaire (BRS), un dispositif innovant permettant d'acheter son logement 30 à 50% moins cher. Conditions d'éligibilité au BRS, avantages, inconvénients, où trouver un logement en BRS... on vous explique tout sur le bail réel solidaire",
    firstPublishedAt: '2025-06-12T10:38:39.527438+01:00',
    updatedAt: '2026-05-28T00:00:00+02:00',
    slug: 'le-bail-reel-solidaire-brs-cest-quoi-exactement',
  },
  {
    title: 'Puis-je acheter un logement en BRS si je suis déjà propriétaire?',
    description:
      'Si vous êtes déjà propriétaire, êtes-vous éligible au Bail Réel Solidaire ? Nous vous proposons de répondre à cette question dans cet article.',
    firstPublishedAt: '2025-03-05T17:29:39.527438+01:00',
    updatedAt: '2026-05-28T00:00:00+02:00',
    slug: 'puis-je-acheter-un-logement-en-brs-si-je-suis-deja-proprietaire',
  },
  {
    title:
      'Acheter son logement sans se ruiner : 3 solutions à connaître absolument',
    description:
      "Accéder à la propriété peut sembler compliqué, mais des solutions comme le Bail Réel Solidaire, le Prêt à Taux Zéro et le PSLA permettent d'acheter un logement dans des conditions avantageuses. Découvrez comment ces dispositifs peuvent vous aider à concrétiser votre projet.",
    firstPublishedAt: '2025-01-07T13:42:15.899904+01:00',
    updatedAt: '2026-05-28T00:00:00+02:00',
    slug: 'acheter-son-logement-sans-se-ruiner-3-solutions-a-connaitre-absolument',
  },
  {
    title: 'Un exemple pour vous projeter dans votre achat en BRS',
    description:
      'Imaginons que vous avez repéré un appartement NEUF de 70 m² en BRS à 210.000 euros à Lyon. Voici un […]',
    firstPublishedAt: '2024-11-21T11:18:13.129273+01:00',
    slug: 'un-exemple-pour-vous-projeter-dans-votre-achat-en-brs',
  },
];
